var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12246 16.4729C9.12174 17.3599 11.503 17.3117 13.5421 16.1344C16.93 14.1784 18.0908 9.84627 16.1348 6.45837L15.9265 6.09752M3.86571 13.5418C1.9097 10.1539 3.07048 5.8218 6.45839 3.86579C8.49754 2.68848 10.8788 2.64031 12.878 3.52728M2.07812 13.6115L4.35483 14.2216L4.96488 11.9448M15.0358 8.05488L15.6459 5.77818L17.9226 6.38822",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.05be578d2dd2b0f3b042815ab5f50809.svg";
export { ForwardRef as ReactComponent };